module.exports = __webpack_public_path__ + "assets/a8d7bfadc9469ab67289158c23f33e7f.png";